import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Flame, MessageCircle, User, Heart, Crown } from 'lucide-react';

export const BottomNav = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const navItems = [
    { path: '/discover', icon: Flame, label: 'Discover', testId: 'nav-discover' },
    { path: '/matches', icon: Heart, label: 'Matches', testId: 'nav-matches' },
    { path: '/subscription', icon: Crown, label: 'Premium', testId: 'nav-subscription' },
    { path: '/profile', icon: User, label: 'Profile', testId: 'nav-profile' },
  ];

  return (
    <nav
      className="fixed bottom-6 left-1/2 -translate-x-1/2 bg-white/80 backdrop-blur-xl border border-white/20 shadow-2xl rounded-full px-8 py-4 flex gap-8 z-50"
      data-testid="bottom-navigation"
    >
      {navItems.map((item) => {
        const Icon = item.icon;
        const isActive = location.pathname === item.path;
        return (
          <button
            key={item.path}
            onClick={() => navigate(item.path)}
            className={`flex flex-col items-center gap-1 transition-colors ${
              isActive ? 'text-electric-coral' : 'text-slate-400 hover:text-slate-600'
            }`}
            data-testid={item.testId}
          >
            <Icon className="w-6 h-6" fill={isActive ? 'currentColor' : 'none'} />
            <span className="text-xs font-medium">{item.label}</span>
          </button>
        );
      })}
    </nav>
  );
};